import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

export const Searchin = (props: SvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 24 24"
      {...props}
    >
      <g fill="none">
        <path
          fill={props.htmlColor || theme.palette.secondary[100]}
          fillOpacity="0.16"
          d="M11 19a8 8 0 1 0 0-16a8 8 0 0 0 0 16"
        />
        <path
          stroke={props.htmlColor || theme.palette.secondary[200]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
          d="m21 21l-4-4m2-6a8 8 0 1 1-16 0a8 8 0 0 1 16 0"
        />
      </g>
    </SvgIcon>
  );
};
